{
  "title": "Worldwide Shipping",
  "description": "USA, Delaware based parcel forwarding service shipping globally",
  "canonicalUrl": "https://app.eastshipper.com/",
  "themeColor": "#3e82f7",
  "ogImagePath": "/partners/eastshipper/og-image.png"
}
